import { FallbackProps } from 'react-error-boundary';
import * as Sentry from '@sentry/react';
import { Button } from 'antd';
import styles from './ErrorFallback.module.less';

export const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const errHandleClick = () => {
    //先清除老数据  保证不会报错
    localStorage.removeItem('persist:root_develop');
    window.location.reload();
  };
  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <div className={styles.container}>
        <div className={styles.btnDesc}>
          <p>ERROR</p>
          <div className={styles.text}>
            Please contact the hosting provider of your website, provide them the Detail information
            above and ask them to release the restriction. After that, please try to link the
            website again.
          </div>
          <Button type="primary" onClick={errHandleClick} className={styles.btn}>
            RESETERRORBOUNDARY
          </Button>

          <img
            src="https://img.dsers.com/develop_center/error.JPG.png"
            className={styles.error}
          ></img>
        </div>
      </div>
    </Sentry.ErrorBoundary>
  );
};
